import gettext from 'i18n/gettext';
const flow = {
    name: gettext('Vault Exchange'),
    cancel: {
        state: 'holding.dashboard.metals.vault-exchange',
    },
    complete: {
        label: gettext('Return to Overview'),
        state: 'holding.dashboard.overview',
        options: {
            reload: true,
        },
    },
    steps: [
        {
            key: 'metal',
            state: 'holding.dashboard.metals.vault-exchange.source',
            heading: gettext('Exchange Your Metal to Another Vault'),
            label: gettext('Select Metal'),
        },
        {
            key: 'amount',
            state: 'holding.dashboard.metals.vault-exchange.destination',
            heading: gettext('Choose a Destination Vault'),
            label: gettext('Select Destination'),
        },
        {
            key: 'review',
            state: 'holding.dashboard.metals.vault-exchange.review',
            cancel: true,
            heading: gettext('Review Vault Exchange'),
            label: gettext('Review Exchange'),
            controls: {
                next: gettext('Place Order'),
            },
        },
        {
            key: 'complete',
            state: 'holding.dashboard.metals.vault-exchange.complete',
            complete: true,
            label: gettext('Complete'),
        },
    ],
};
export default flow;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/metals/states/metals/vault-exchange/vault-exchange-flow.ts